import PolicyRouteConstants from 'Agent/Policies/PolicyRouteConstants';

export default {
  CLAIMS: (policyNumber: string) => `${PolicyRouteConstants.POLICIES}/${policyNumber}/claims`,
};
